module.exports = __webpack_public_path__ + "img/img-2.5da0a5b.jpg";